import { render, staticRenderFns } from "./CensusChanges.vue?vue&type=template&id=9d7927b8&scoped=true&"
import script from "./CensusChanges.vue?vue&type=script&lang=js&"
export * from "./CensusChanges.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d7927b8",
  null
  
)

export default component.exports